import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-19" data-mp="3c1mi0hnvqjxn">
      <p className={`flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-wider ${dark ? "text-gold" : "text-navy"}`} data-id="element-20" data-mp="3h0z6t7yba12v">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="3262qe7gcm7ep" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-22" data-mp="374mcq8yutl7l">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="10aina48aql7u" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="15adc828ih0q9">
              <span className={`grid h-[68px] w-[68px] place-items-center rounded-xl font-serif text-4xl font-black tabular-nums md:h-20 md:w-20 md:text-5xl ${dark ? "bg-gold text-navy" : "bg-navy text-white"}`} data-id="element-25" data-mp="159263vrlfgvz">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-bold uppercase tracking-widest ${dark ? "text-white/70" : "text-navy/60"}`} data-id="element-26" data-mp="12rd9xb0hts9h">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-black md:pt-5 ${dark ? "text-gold" : "text-navy"}`} aria-hidden="true" data-id="element-27" data-mp="o38y8qzuyh07">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}